import { render, staticRenderFns } from "./ReceivableStatementDetails.vue?vue&type=template&id=1c40224f&scoped=true"
import script from "./ReceivableStatementDetails.vue?vue&type=script&lang=ts"
export * from "./ReceivableStatementDetails.vue?vue&type=script&lang=ts"
import style0 from "./ReceivableStatementDetails.vue?vue&type=style&index=0&id=1c40224f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c40224f",
  null
  
)

export default component.exports